import React from "react";
import ReactMarkdown from "react-markdown";

export default function PublishPrompt({
  orderedGuardrails,
  setSelectedView,
  handlePublish,
}) {
  return (
    <div className="publish-prompt">
      <div className="publish-list-header">
        <h5>Prompt Content</h5>
      </div>
      <div className="publish-list-body">
        {orderedGuardrails.map((guardrail) => {
          return (
            <ReactMarkdown key={guardrail?.id}>
              {guardrail?.promptContent}
            </ReactMarkdown>
          );
        })}
      </div>
      <div className="publish-list-footer">
        <button
          className="publish-list-button-cancel"
          onClick={() => setSelectedView()}
        >
          Cancel
        </button>
        <button className="publish-list-button" onClick={() => handlePublish()}>
          Publish
        </button>
      </div>
    </div>
  );
}
